import * as React from 'react'

const NotFound = () => {

    return <div>
        <div> Page not found</div>
    </div>
}

export default NotFound